import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { ChildrenPropType } from '../../services/proptypes';
import IconElement from '../IconElement';
var defaultProps = {
  iconAs: 'icon'
};
export default function HoursOfOperationModal(props) {
  var iconAs = props.iconAs,
      children = props.children;
  return /*#__PURE__*/React.createElement(Modal, {
    className: "hoo-modal",
    dimmer: "inverted",
    trigger: iconAs === 'icon' ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "hoo-modal-trigger"
    }, /*#__PURE__*/React.createElement(IconElement, {
      iconType: "clock",
      element: /*#__PURE__*/React.createElement("span", null, "See Hours"),
      iconPosition: "left"
    })) : /*#__PURE__*/React.createElement(Button, {
      icon: "clock",
      secondary: true
    })
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("div", null, "Hours Of Operation")), /*#__PURE__*/React.createElement(Modal.Content, null, children));
}
HoursOfOperationModal.defaultProps = defaultProps;